import { path } from 'ramda';
var api = function api(err) {
  return path(['response', 'data', 'error'], err) || err.toString().replace('Error: ', '');
};
export default {
  api: api
};